<template>
  <div class="base-info">
    <a-card title="账号列表" :bordered="false" :headStyle="{paddingLeft:'0px'}">
    </a-card>
    <a-button type="primary" style="margin-top: 20px;margin-bottom: 20px" @click="addAccount">
      + 添加账号
    </a-button>
    <custom-page-table
      ref="table"
      rowKey="userId"
      :columns="columns"
      :requestPromise="getRequestPromise">
      <template slot="userStatus" slot-scope="rowItem">
        <!--账户状态:0表示禁用，1表示启用-->
        <span v-if="rowItem.text===0">
          <a-badge dot style="margin-right: 10px"></a-badge>
          禁用
        </span>
        <span v-else class="custom">
          <a-badge dot style="margin-right: 10px"/>
          正常
        </span>
      </template>
      <template slot="lastLoginTime" slot-scope="rowItem">{{ rowItem.text ? rowItem.text : '----' }}</template>
      <template slot="action" slot-scope="rowItem">
        <a @click="toEditor(rowItem.record)">修改</a>
        <a-divider type="vertical"></a-divider>
        <span @click="updateUserState(rowItem.record.userId,rowItem.text)">
          <a v-if="rowItem.record.userStatus===1">禁用</a>
        <a v-else>启用</a>
        </span>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm
          title="是否要重置当前账号密码为a123456？"
          @confirm="resetPassWord(rowItem.record)">
          <a>重置密码</a>
        </a-popconfirm>
      </template>
    </custom-page-table>
    <a-modal
      title="创建子账号"
      :width="800"
      v-model="visible"
      @ok="saveEvent"
      @cancel="visible=false"
      :destroyOnClose='false'
    >
      <a-form :form="form">
        <a-form-item label="姓名" v-bind="customFormItemLayout">
          <a-input
            v-decorator="['userName', {rules:[{required: true, message:'请输入姓名'}],validateTrigger: 'change,blur'}]"
            placeholder="请输入姓名"
          ></a-input>
        </a-form-item>
        <a-form-item label="手机号" v-bind="customFormItemLayout">
          <a-input
            v-decorator="['userMobile', {rules: [{ required: true, validator: handlePhoneInput }], validateTrigger: 'change,blur'}]"
            placeholder="请输入手机号"
          ></a-input>
        </a-form-item>
        <a-form-item label="登录邮箱" v-bind="customFormItemLayout">
          <a-input
            v-decorator="['userEmail', {rules: [{ required: true, message:'请输入邮箱',validator: handleEmailInput}], validateTrigger: 'change,blur'}]"
            placeholder="请输入邮箱"
          ></a-input>
        </a-form-item>
        <a-form-item label="角色名称" v-bind="customFormItemLayout">
          <a-select
            style="max-width: 400px"
            v-decorator="['roleId', {rules:[{required: true, message:'请选择'}]}]"
            placeholder="请选择角色"
          >
            <a-select-option v-for="item in roleList" :key="item.roleId" :value="item.roleId">{{ item.roleName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="!selectedRecord" label="登录密码" v-bind="customFormItemLayout">
          <a-input
            v-decorator="['userPwd', {rules:[{required: true, message:'请输入密码'}],validateTrigger: 'change,blur'}]"
            type="password"
            placeholder="请输入密码"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>

</template>

<script>
import formMixin from '../../../utils/mixins/formMixins'
import userHelper from '../../../utils/helper/userHelper'

export default {
  name: 'AccountListComponents',
  mixins: [formMixin],
  data() {
    return {
      visible: false,
      roleList: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'userId'
        },
        {
          title: '真实姓名',
          dataIndex: 'userName'
        },
        {
          title: '账号名',
          dataIndex: 'userEmail'
        },
        {
          title: '手机号',
          dataIndex: 'userMobile'
        },
        {
          title: '角色名称',
          dataIndex: 'roleName'
        },
        {
          title: '状态',
          dataIndex: 'userStatus',
          width: '85px',
          scopedSlots: { customRender: 'userStatus' }
        },

        {
          title: '最近登录',
          dataIndex: 'lastLoginTime',
          scopedSlots: { customRender: 'lastLoginTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      customFormItemLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 19
        }
      },
      selectedRecord: undefined,
      activatedFlag: 0
    }
  },

  mounted() {
    this.activatedFlag = 1
  },
  activated() {
    this.activatedFlag = this.activatedFlag + 1
    if (this.activatedFlag > 2) {//避免强刷时多次调用
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    getRequestPromise(params) {
      return this.getHttpServices().getPermissionService().post('permission/v2/getSubAccountPage', params)
    },
    getRoleList() {
      this.getHttpServices().getPermissionService()
        .post('roleLimits/selectRoleList')
        .then(list => {
          this.roleList = list
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    addAccount() {
      this.visible = true
      this.selectedRecord = undefined
      this.getRoleList()
      this.$nextTick(() => {
        this.form.setFieldsValue({
          userName: '',
          userMobile: '',
          userEmail: '',
          roleId: '',
          userPwd: ''
        })
      })
    },
    toEditor(record) {
      this.selectedRecord = record
      this.visible = true
      this.getRoleList()
      this.$nextTick(() => {
        this.form.setFieldsValue({
          userName: record.userName,
          userMobile: record.userMobile,
          userEmail: record.userEmail,
          roleId: record.roleId
        })
      })
    },
    updateUserState(userId, state) {
      this.getHttpServices().getPermissionService()
        .post('roleLimits/updateStatus/' + userId)
        .then(res => {
          let tips = (state === 1) ? '账号禁用成功' : '账号启用成功'
          this.$message.success(tips)
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //重置密码
    resetPassWord(record) {
      const userPwd = userHelper.getPasswordEncrypt('a123456')
      const path = 'roleLimits/resetPwd/' + record.userId + '/' + userPwd
      this.getHttpServices().getPermissionService().get(path)
        .then(res => {
          this.$message.success('密码重置成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    saveEvent() {
      this.validateFormParams()
        .then(values => {
          let update = false
          if (values.userPwd) {//加密密码
            values.userPwd = userHelper.getPasswordEncrypt(values.userPwd)
          } else if (this.selectedRecord) {
            values.userId = this.selectedRecord.userId
            update = true
          }
          this.saveOrUpdateRequest(update, values)
        }).catch(reason => this.getLogUtils().errorWithTag('saveEvent', reason))
    },
    saveOrUpdateRequest(update, params) {
      this.getHttpServices().getPermissionService().post('roleLimits/saveOrUpdateMerchantUser', params)
        .then(res => {
          this.visible = false
          let tips = update ? '账号更新成功' : '账号添加成功'
          this.$message.success(tips)
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less">
.custom {
  .ant-badge-dot {
    background: green;
  }
}
</style>